define('lq/events/actions/mollie',[
    'lq/events/actions/eventAction'
], function (EventAction) {
    'use strict';

    function Mollie(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        return this;
    }

    EventAction.extend(Mollie, EventAction);

    Mollie.typeName = 'Mollie';

    Mollie.prototype.getBatchType = function() {
        return EventAction.COMMAND_BATCH;
    };

    Mollie.prototype.createEventActionRequest = function () {
        return {
            eventActionType: "CreateMolliePayment",
            commandId: this.eventData.command
        };
    };

    Mollie.prototype.execute = function(continuation, eventActionResponse) {
        if (eventActionResponse.paymentUrl)
            window.location.href = eventActionResponse.paymentUrl;
        else
            continuation();
    };

    Mollie.prototype.handleError = function(eventName, defaultMessage, continuation) {
        if (this.eventIsEnabled(eventName)) {
            this.triggerEvent(eventName, continuation);
        } else {
            alert(defaultMessage);
            continuation();
        }
    };

    return Mollie;
});
